import Vue from 'vue'
import sinisterTransformer from '@/transformers/catalog/warehouse/sinistersInSM'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch sinister list in status SM 
 * @return {List}
 */

function urlParamsTransformer(opts) {
  return {
    warehouse: opts.warehouse,
    status: opts.status
  }
}
export default (opts) => {
  let config
  if(opts) {
    config = {
      params: urlParamsTransformer(opts)
    }
  }
  return Vue.$http.get(`iwarehouse/report/to-be-approved/`, config)
    .then(({ data }) => sinisterTransformer.fetchCollection(data))
    .catch(error => {throw error})
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchSinistersSM.js